import React, { useState } from 'react';
import { useParkingWizardStore, ParkingVehicleEntry } from 'Stores/ParkingWizardStore';

export function ParkingVehiclesStep() {
	const { vehicles, addVehicle, removeVehicle, updateVehicle, note, setNote, setStep, setError } =
		useParkingWizardStore();

	const [newVehicle, setNewVehicle] = useState<Partial<ParkingVehicleEntry>>({
		parkingVehicleTypeId: '',
		parkingVehicleTypeName: '',
		startDate: '',
		endDate: '',
	});

	const handleAddVehicle = () => {
		if (!newVehicle.parkingVehicleTypeId || !newVehicle.startDate || !newVehicle.endDate) {
			setError('Please fill in all vehicle fields.');
			return;
		}
		if (new Date(newVehicle.endDate) <= new Date(newVehicle.startDate)) {
			setError('End date must be after start date.');
			return;
		}
		setError(null);
		addVehicle(newVehicle as ParkingVehicleEntry);
		setNewVehicle({ parkingVehicleTypeId: '', parkingVehicleTypeName: '', startDate: '', endDate: '' });
	};

	const handleContinue = () => {
		if (vehicles.length === 0) {
			setError('Please add at least one vehicle.');
			return;
		}
		setError(null);
		setStep('review');
	};

	const handleBack = () => {
		setError(null);
		setStep('location');
	};

	return (
		<div className="parking-wizard__step parking-vehicles-step">
			<h2>Add Your Vehicles</h2>

			{vehicles.length > 0 && (
				<div className="parking-vehicles-step__list">
					{vehicles.map((vehicle, index) => (
						<div key={vehicle.parkingVehicleTypeId} className="parking-vehicles-step__vehicle-card">
							<div className="parking-vehicles-step__vehicle-info">
								<span className="parking-vehicles-step__vehicle-label">
									{vehicle.parkingVehicleTypeName || vehicle.parkingVehicleTypeId}
								</span>
								<span className="parking-vehicles-step__vehicle-dates">
									{vehicle.startDate} &mdash; {vehicle.endDate}
								</span>
							</div>
							<button
								type="button"
								className="btn btn-sm btn-outline-danger"
								onClick={() => removeVehicle(index)}
							>
								Remove
							</button>
						</div>
					))}
				</div>
			)}

			<div className="parking-vehicles-step__add-form">
				<h3>Add Vehicle</h3>
				<div className="parking-vehicles-step__form-row">
					<label htmlFor="parking-vehicle-type-id">
						Vehicle Type
						<input
							id="parking-vehicle-type-id"
							type="text"
							className="form-control"
							placeholder="Enter vehicle type"
							value={newVehicle.parkingVehicleTypeId ?? ''}
							onChange={e => setNewVehicle({ ...newVehicle, parkingVehicleTypeId: e.target.value })}
						/>
					</label>
				</div>
				<div className="parking-vehicles-step__form-row">
					<label htmlFor="parking-vehicle-type-name">
						Vehicle Type Name (e.g. registration)
						<input
							id="parking-vehicle-type-name"
							type="text"
							className="form-control"
							placeholder="e.g. ABC-123"
							value={newVehicle.parkingVehicleTypeName ?? ''}
							onChange={e => setNewVehicle({ ...newVehicle, parkingVehicleTypeName: e.target.value })}
						/>
					</label>
				</div>
				<div className="parking-vehicles-step__form-row">
					<label htmlFor="parking-start-date">
						Start Date
						<input
							id="parking-start-date"
							type="date"
							className="form-control"
							value={newVehicle.startDate ?? ''}
							onChange={e => setNewVehicle({ ...newVehicle, startDate: e.target.value })}
						/>
					</label>
				</div>
				<div className="parking-vehicles-step__form-row">
					<label htmlFor="parking-end-date">
						End Date
						<input
							id="parking-end-date"
							type="date"
							className="form-control"
							value={newVehicle.endDate ?? ''}
							onChange={e => setNewVehicle({ ...newVehicle, endDate: e.target.value })}
						/>
					</label>
				</div>
				<button type="button" className="btn btn-secondary" onClick={handleAddVehicle}>
					Add Vehicle
				</button>
			</div>

			<div className="parking-vehicles-step__note">
				<label htmlFor="parking-note">
					Note (optional)
					<textarea
						id="parking-note"
						className="form-control"
						rows={3}
						value={note}
						onChange={e => setNote(e.target.value)}
						placeholder="Any additional information..."
					/>
				</label>
			</div>

			<div className="parking-wizard__actions">
				<button type="button" className="btn btn-outline-secondary" onClick={handleBack}>
					Back
				</button>
				<button
					type="button"
					className="btn btn-primary"
					onClick={handleContinue}
					disabled={vehicles.length === 0}
				>
					Continue
				</button>
			</div>
		</div>
	);
}
